export const getRoleDashboardLink = (role, t) => {
  switch (role) {
    case 'ADMIN':
      return {
        path: '/dash',
        label: t('navbar.adminButton'),
      };
    case 'SURGEON':
      return {
        path: '/surgeon/profile',
        label: t('navbar.surgeonProfileButton'),
      };
    case 'USER':
      return {
        path: '/user',
        label: t('navbar.userButton'),
      };
    default:
      return null;
  }
};
